<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ deleteError }}</span>
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Name</th>
            <td>{{ item['name'] }}</td>
          </tr>
          <tr>
            <th scope="row">Created</th>
            <td>{{ item['created'] }}</td>
          </tr>
          <tr>
            <th scope="row">Source Url</th>
            <td>{{ item['sourceUrl'] }}</td>
          </tr>
          <tr>
            <th scope="row">Speaker</th>
            <td v-if="item['speaker'] != null">
              {{ item['speaker'].name }}
            </td>
            <td v-else>
            </td>
          </tr>         
          <tr>
            <th scope="row">Testimonials</th>
            <td v-if="item['testimonials'] != ''">
               <router-link                
                :to="{ name: 'TestimonialListAudio', params: { id: item['id'] }}">
                {{ item['testimonials'].length }}
              </router-link></td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'AudioList' }"
      class="btn btn-primary">
      Back to list
    </router-link>
    <router-link
      v-if="item"
      :to="{ name: 'AudioUpdate', params: { id: item['@id'] } }"
      class="btn btn-warning">
      Edit
    </router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data() {
    return {      
    }
  },
  computed: {
    ...mapFields('audio/del', {
      deleteError: 'error',
    }),
    ...mapFields('audio/show', {
      error: 'error',
      isLoading: 'isLoading',
      item: 'retrieved',
    }),     
    ...mapFields('speaker/list', {
      'speakerSelectItems': 'selectItems',
    }),
  },

  beforeDestroy () {
    this.reset();
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id));
  },

  methods: {
    ...mapActions({
      del: 'audio/del/del',
      reset: 'audio/show/reset',
      retrieve: 'audio/show/retrieve',
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'AudioList' }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/audio/Show.vue